import React, { useContext, useEffect, useMemo } from 'react';
import { useIsValidatingUser } from '../hooks/useIsValidatingUser';

export const UserValidationContext = React.createContext()

export const UserValidationProvider = ({ children }) => {
    const state = useIsValidatingUser();
    const value = useMemo(() => state, [state])

    //useEffect(() => { console.log("UserValidationProvider => ", value) }, [value])

    return (
        <UserValidationContext.Provider value={value}>
            {children}
        </UserValidationContext.Provider>
    );
}

export function useUserValidationContext() {
    return useContext(UserValidationContext)
}

